export default "__VITE_ASSET__D14LMF_M__"